import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';
import { ErrorNotFound } from 'components/pages/ErrorNotFound';
import { OverviewRoute } from 'components/pages/OverviewRoute';
import { Performance } from 'components/pages/Performance';
import { Pipeline } from 'components/pages/Pipeline';
import { Academy } from 'components/pages/Academy';

const routes: Array<RouteObject> = [
  {
    path: '/overview',
    element: <OverviewRoute />,
  },
  {
    path: '/pipeline',
    element: <Pipeline />,
  },
  {
    path: '/listview',
    element: <Pipeline />,
  },
  {
    path: '/performance/*',
    element: <Performance />,
  },
  {
    path: '/academy',
    element: <Academy />,
  },
  {
    path: '/',
    element: <Navigate to="/overview" replace />,
  },
  {
    path: '/dashboard',
    element: <Navigate to="/overview" replace />,
  },
  {
    path: '*',
    element: <ErrorNotFound />,
  },
];

const router = createBrowserRouter(routes);

export { router };
